import { useProvideTeleport } from "./useTeleport.js";
import { Fragment, createElementBlock, createElementVNode, defineComponent, openBlock, renderSlot, unref } from "vue";
//#region src/components/ScalarTeleport/ScalarTeleportRoot.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1 = ["id"];
var ScalarTeleportRoot_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	inheritAttrs: false,
	__name: "ScalarTeleportRoot",
	props: { id: {} },
	setup(__props) {
		const id = useProvideTeleport(__props.id);
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock(Fragment, null, [renderSlot(_ctx.$slots, "default"), createElementVNode("div", {
				id: unref(id),
				class: "scalar-teleport-root contents"
			}, null, 8, _hoisted_1)], 64);
		};
	}
});
//#endregion
export { ScalarTeleportRoot_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=ScalarTeleportRoot.vue.script.js.map